// Separate module so vi.mock can intercept in tests.
export function copyToClipboard(text: string): Promise<void> {
  return navigator.clipboard.writeText(text);
}
